import React from 'react';
import { Link } from 'react-router-dom';
import heroVideo from '../assets/videos/hero_video.mp4';
import { Car, Plane, Heart, Activity, Users, Award, UserCheck } from 'lucide-react';

// Import logos for partners (Hardcoded for now based on file list, in a real app could be dynamic)
import logo1 from '../assets/logos/camsp.jpeg';
import logo2 from '../assets/logos/centre-hospitalier-theophile-roussel-1024x1008-1.png';
import logo3 from '../assets/logos/cesap.png';
import logo4 from '../assets/logos/hopital_meulan-scaled.jpg';

const partners = [logo1, logo2, logo3, logo4, logo1, logo2, logo3, logo4]; // Duplicated for scroll effect

const Home = () => {
    return (
        <div>
            {/* Hero Section */}
            <section style={{ position: 'relative', height: '90vh', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover', // Ensures video covers the entire container
                        zIndex: -1,
                        filter: 'brightness(0.5)' // Darken video for text readability
                    }}
                >
                    <source src={heroVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <div className="container" style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
                    <h1 style={{ fontSize: '4rem', marginBottom: '1.5rem', opacity: 0, animation: 'fadeInUp 1s ease forwards', color: 'white' }}>
                        2ATP-MR
                    </h1>
                    <p style={{ fontSize: '1.5rem', maxWidth: '800px', margin: '0 auto 2rem', opacity: 0, animation: 'fadeInUp 1s ease 0.3s forwards' }}>
                        Votre service de transport conventionné en Île-de-France
                    </p>
                    <div style={{ opacity: 0, animation: 'fadeInUp 1s ease 0.6s forwards' }}>
                        <Link to="/contact" className="btn btn-primary" style={{ marginRight: '1rem' }}>Réserver un trajet</Link>
                        <Link to="/services" className="btn btn-outline" style={{ borderColor: 'white', color: 'white' }}>Nos Services</Link>
                    </div>
                </div>
            </section>

            {/* Partners Infinite Scroll */}
            <section className="section" style={{ backgroundColor: '#f8fafc', overflow: 'hidden' }}>
                <div className="container" style={{ marginBottom: '2rem', textAlign: 'center' }}>
                    <h3>Ils nous font confiance</h3>
                </div>

                <div className="logos-slider" style={{ display: 'flex', width: '200%', animation: 'scroll 30s linear infinite' }}>
                    <div className="logos-slide" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '50%' }}>
                        {partners.map((logo, index) => (
                            <img key={index} src={logo} alt="Partenaire" style={{ height: '80px', objectFit: 'contain', margin: '0 2rem', filter: 'grayscale(100%)', opacity: 0.7, transition: 'all 0.3s' }}
                                onMouseOver={(e) => { e.currentTarget.style.filter = 'grayscale(0%)'; e.currentTarget.style.opacity = 1 }}
                                onMouseOut={(e) => { e.currentTarget.style.filter = 'grayscale(100%)'; e.currentTarget.style.opacity = 0.7 }}
                            />
                        ))}
                    </div>
                    <div className="logos-slide" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '50%' }}>
                        {partners.map((logo, index) => (
                            <img key={`dup-${index}`} src={logo} alt="Partenaire" style={{ height: '80px', objectFit: 'contain', margin: '0 2rem', filter: 'grayscale(100%)', opacity: 0.7, transition: 'all 0.3s' }}
                                onMouseOver={(e) => { e.currentTarget.style.filter = 'grayscale(0%)'; e.currentTarget.style.opacity = 1 }}
                                onMouseOut={(e) => { e.currentTarget.style.filter = 'grayscale(100%)'; e.currentTarget.style.opacity = 0.7 }}
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* Intro Services */}
            <section className="section" style={{ backgroundColor: 'white' }}>
                <div className="container">
                    <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
                        <h2>Nos Services</h2>
                        <p className="text-light">Un accompagnement adapté à chacun de vos besoins</p>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
                        <ServiceCard
                            icon={<Heart size={40} />}
                            title="Transport PMR"
                            desc="Accompagnement personnalisé pour les personnes à mobilité réduite."
                        />
                        <ServiceCard
                            icon={<Activity size={40} />}
                            title="Centres Spécialisés"
                            desc="Transport vers les centres de soins et établissements spécialisés."
                        />
                        <ServiceCard
                            icon={<Car size={40} />}
                            title="Transport Conventionné"
                            desc="Agréé par la Sécurité Sociale pour vos transports médicaux."
                        />
                        <ServiceCard
                            icon={<Plane size={40} />}
                            title="Transfert Aéroports/Gares"
                            desc="Liaisons ponctuelles et confortables vers les gares et aéroports."
                        />
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '3rem' }}>
                        <Link to="/services" className="btn btn-outline">Voir tous nos services</Link>
                    </div>
                </div>
            </section>

            {/* Comfort & Values Section */}
            <section className="section" style={{ backgroundColor: '#bae6fd' }}>
                <div className="container">
                    <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
                        <h2 style={{ fontSize: '2.5rem', lineHeight: '1.3', color: '#0f172a', maxWidth: '800px', margin: '0 auto' }}>
                            Nous nous assurons de votre confort lors de votre voyage à nos côtés.
                        </h2>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))', gap: '3rem' }}>
                        {/* Item 1 */}
                        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
                            <div style={{
                                backgroundColor: 'white',
                                padding: '1rem',
                                borderRadius: '12px',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                minWidth: '80px', height: '80px',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
                            }}>
                                <Users size={32} color="#0f172a" />
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: 'bold' }}>Accompagnement sur mesure</h3>
                                <p style={{ color: '#334155', lineHeight: '1.6' }}>
                                    Nous sélectionnons des chauffeurs qualifiés possédant les qualités et les compétences nécessaires pour vous accompagner dans vos déplacements.
                                </p>
                            </div>
                        </div>

                        {/* Item 2 */}
                        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
                            <div style={{
                                backgroundColor: 'white',
                                padding: '1rem',
                                borderRadius: '12px',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                minWidth: '80px', height: '80px',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
                            }}>
                                <Car size={32} color="#0f172a" />
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: 'bold' }}>Un Transport Privé Confortable et Fiable</h3>
                                <p style={{ color: '#334155', lineHeight: '1.6' }}>
                                    Nous ne faisons pas de différence entre le transport privé, conventionné, scolaire ou encore pour les personnes âgées ou à mobilité réduite. Notre mission est de vous faciliter la mobilité.
                                </p>
                            </div>
                        </div>

                        {/* Item 3 */}
                        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
                            <div style={{
                                backgroundColor: 'white',
                                padding: '1rem',
                                borderRadius: '12px',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                minWidth: '80px', height: '80px',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
                            }}>
                                <Award size={32} color="#0f172a" />
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: 'bold' }}>Une Expertise Forgée par le Temps</h3>
                                <p style={{ color: '#334155', lineHeight: '1.6' }}>
                                    Nous exerçons notre mission depuis 7 ans et travaillons avec de grandes structures qui nous ont permis de nous développer.
                                </p>
                            </div>
                        </div>

                        {/* Item 4 */}
                        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
                            <div style={{
                                backgroundColor: 'white',
                                padding: '1rem',
                                borderRadius: '12px',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                minWidth: '80px', height: '80px',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
                            }}>
                                <UserCheck size={32} color="#0f172a" />
                            </div>
                            <div>
                                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: 'bold' }}>Des Chauffeurs Expérimentés et Professionnels</h3>
                                <p style={{ color: '#334155', lineHeight: '1.6' }}>
                                    Nos chauffeurs sont soigneusement sélectionnés pour leur expérience, leur ponctualité et leur sens du service. Formés pour garantir un transport fluide, confortable et sécurisé.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Mobile responsive fix for this section */}
                    <style>{`
                        @media (max-width: 768px) {
                            div[style*="gridTemplateColumns"] {
                                grid-template-columns: 1fr !important;
                            }
                            div[style*="minmax(500px, 1fr)"] {
                                grid-template-columns: 1fr !important;
                            }
                        }
                    `}</style>
                </div>
            </section>



            {/* Fleet Teaser */}
            <section className="section" style={{ backgroundColor: '#1e293b', color: 'white', textAlign: 'center' }}>
                <div className="container">
                    <h2 style={{ color: 'white' }}>Une Flotte Adaptée</h2>
                    <p style={{ maxWidth: '600px', margin: '0 auto 2rem', color: '#94a3b8' }}>
                        Des véhicules récents, confortables et adaptés à tous types de transport. Berlines, vans, et véhicules TPMR.
                    </p>
                    <Link to="/fleet" className="btn btn-primary">Découvrir notre flotte</Link>
                </div>
            </section>

            <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
        </div>
    );
};

const ServiceCard = ({ icon, title, desc }) => (
    <div style={{
        padding: '2rem',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.3s ease',
        cursor: 'pointer'
    }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
    >
        <div style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>{icon}</div>
        <h3 style={{ fontSize: '1.25rem', marginBottom: '0.5rem' }}>{title}</h3>
        <p style={{ color: 'var(--text-light)', fontSize: '0.95rem' }}>{desc}</p>
    </div>
);

export default Home;
